import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-neutral-900 text-white mt-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <span className="text-neutral-900 font-light text-lg">F&C</span>
              </div>
              <span className="text-xl font-light">Freddy & Co.</span>
            </div>
            <p className="text-neutral-400 text-sm mb-6 leading-relaxed">
              Small Breed Specialists. Curated accessories for small & medium breed dogs and all cats. Featuring Freddy the Bichon.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-neutral-400 hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/freddythebichon" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-neutral-400 hover:text-white transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-neutral-400 hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-light text-lg mb-6">Shop</h3>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li><Link to="/products?category=Fluff Essentials" className="hover:text-white transition-colors">Fluff Essentials</Link></li>
              <li><Link to="/products?category=Owner Essentials" className="hover:text-white transition-colors">Owner Essentials</Link></li>
              <li><Link to="/products?category=Apparel" className="hover:text-white transition-colors">Apparel</Link></li>
              <li><Link to="/products" className="hover:text-white transition-colors">All Products</Link></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="font-light text-lg mb-6">About</h3>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li><a href="#" className="hover:text-white transition-colors">Our Story</a></li>
              <li><a href="https://www.instagram.com/freddythebichon" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Meet Freddy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Size Guide</a></li>
            </ul>
          </div>

          {/* Customer Care */}
          <div>
            <h3 className="font-light text-lg mb-6">Customer Care</h3>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Shipping</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Returns</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-800 mt-12 pt-8 text-center text-sm text-neutral-500">
          <p>&copy; 2025 Freddy & Co. Small Breed Specialists.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
